import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import LoadingGate from 'components/LoadingGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ModalWithConfirmation from 'components/ModalWithConfirmation';
import { FERTILIZER_EVENT_COPY_MODAL } from 'scenes/Fertilizer/constants';
import { FERTILIZER_EVENTS_LOAD_NAMESPACE } from 'services/fertilizerEvents/constants';
import FertilizerEventFinalForm from '../FertilizerEventFinalForm';

interface ConnectedProps {
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

export type Props = ConnectedProps & DispatchProps;

export class FertilizerEventEditModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [FERTILIZER_EVENT_COPY_MODAL]: undefined,
            fertilizerEventUuid: undefined
        });
    };

    render(): React.ReactElement {
        const { isOpen } = this.props;

        return (
            <LoadingGate namespace={FERTILIZER_EVENTS_LOAD_NAMESPACE}>
                <CurrentSeasonInProgressGate>
                    <RoleGate
                        requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                    >
                        <ModalWithConfirmation
                            size="fullscreen"
                            open={isOpen}
                            centered={false}
                            onCloseClick={this.handleClose}
                            closeIcon
                            className="spray-event-modal"
                            showConfirmation
                        >
                            <ErrorBoundary
                                namespace="copyEventEditModal"
                                FallbackComponent={<ErrorBoundaryAlert />}
                            >
                                <FertilizerEventFinalForm title="Duplicate Fertilizer Schedule" />
                            </ErrorBoundary>
                        </ModalWithConfirmation>
                    </RoleGate>
                </CurrentSeasonInProgressGate>
            </LoadingGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue(FERTILIZER_EVENT_COPY_MODAL)
});

export default connect(mapStateToProps, {
    updateQueryString
})(FertilizerEventEditModalComponent);
